/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExperimentalMutant } from './ExperimentalMutant';
import {
    ExperimentalMutantFromJSON,
    ExperimentalMutantFromJSONTyped,
    ExperimentalMutantToJSON,
    ExperimentalMutantToJSONTyped,
} from './ExperimentalMutant';
import type { Disease } from './Disease';
import {
    DiseaseFromJSON,
    DiseaseFromJSONTyped,
    DiseaseToJSON,
    DiseaseToJSONTyped,
} from './Disease';
import type { ResistanceItem } from './ResistanceItem';
import {
    ResistanceItemFromJSON,
    ResistanceItemFromJSONTyped,
    ResistanceItemToJSON,
    ResistanceItemToJSONTyped,
} from './ResistanceItem';
import type { BinaryInteraction } from './BinaryInteraction';
import {
    BinaryInteractionFromJSON,
    BinaryInteractionFromJSONTyped,
    BinaryInteractionToJSON,
    BinaryInteractionToJSONTyped,
} from './BinaryInteraction';
import type { NaturalVariant } from './NaturalVariant';
import {
    NaturalVariantFromJSON,
    NaturalVariantFromJSONTyped,
    NaturalVariantToJSON,
    NaturalVariantToJSONTyped,
} from './NaturalVariant';
import type { Publication } from './Publication';
import {
    PublicationFromJSON,
    PublicationFromJSONTyped,
    PublicationToJSON,
    PublicationToJSONTyped,
} from './Publication';
import type { Subunit } from './Subunit';
import {
    SubunitFromJSON,
    SubunitFromJSONTyped,
    SubunitToJSON,
    SubunitToJSONTyped,
} from './Subunit';
import type { AssociatedDrug } from './AssociatedDrug';
import {
    AssociatedDrugFromJSON,
    AssociatedDrugFromJSONTyped,
    AssociatedDrugToJSON,
    AssociatedDrugToJSONTyped,
} from './AssociatedDrug';
import type { GoTerm } from './GoTerm';
import {
    GoTermFromJSON,
    GoTermFromJSONTyped,
    GoTermToJSON,
    GoTermToJSONTyped,
} from './GoTerm';

/**
 * 
 * @export
 * @interface Uniprot
 */
export interface Uniprot {
    /**
     * 
     * @type {Array<string>}
     * @memberof Uniprot
     */
    functionDescriptions: Array<string>;
    /**
     * 
     * @type {Array<NaturalVariant>}
     * @memberof Uniprot
     */
    naturalVariants: Array<NaturalVariant>;
    /**
     * 
     * @type {Array<ExperimentalMutant>}
     * @memberof Uniprot
     */
    experimentalMutants: Array<ExperimentalMutant>;
    /**
     * 
     * @type {Array<AssociatedDrug>}
     * @memberof Uniprot
     */
    associatedDrugs: Array<AssociatedDrug>;
    /**
     * 
     * @type {Subunit}
     * @memberof Uniprot
     */
    subunit: Subunit;
    /**
     * 
     * @type {Array<BinaryInteraction>}
     * @memberof Uniprot
     */
    binaryInteractions: Array<BinaryInteraction>;
    /**
     * 
     * @type {Array<GoTerm>}
     * @memberof Uniprot
     */
    molecularFunctions: Array<GoTerm>;
    /**
     * 
     * @type {Array<GoTerm>}
     * @memberof Uniprot
     */
    biologicalProcesses: Array<GoTerm>;
    /**
     * 
     * @type {Array<ResistanceItem>}
     * @memberof Uniprot
     */
    resistance: Array<ResistanceItem>;
    /**
     * 
     * @type {Array<Disease>}
     * @memberof Uniprot
     */
    diseases: Array<Disease>;
    /**
     * 
     * @type {{ [key: string]: Publication; }}
     * @memberof Uniprot
     */
    publications: { [key: string]: Publication; };
}

/**
 * Check if a given object implements the Uniprot interface.
 */
export function instanceOfUniprot(value: object): value is Uniprot {
    if (!('functionDescriptions' in value) || value['functionDescriptions'] === undefined) return false;
    if (!('naturalVariants' in value) || value['naturalVariants'] === undefined) return false;
    if (!('experimentalMutants' in value) || value['experimentalMutants'] === undefined) return false;
    if (!('associatedDrugs' in value) || value['associatedDrugs'] === undefined) return false;
    if (!('subunit' in value) || value['subunit'] === undefined) return false;
    if (!('binaryInteractions' in value) || value['binaryInteractions'] === undefined) return false;
    if (!('molecularFunctions' in value) || value['molecularFunctions'] === undefined) return false;
    if (!('biologicalProcesses' in value) || value['biologicalProcesses'] === undefined) return false;
    if (!('resistance' in value) || value['resistance'] === undefined) return false;
    if (!('diseases' in value) || value['diseases'] === undefined) return false;
    if (!('publications' in value) || value['publications'] === undefined) return false;
    return true;
}

export function UniprotFromJSON(json: any): Uniprot {
    return UniprotFromJSONTyped(json, false);
}

export function UniprotFromJSONTyped(json: any, ignoreDiscriminator: boolean): Uniprot {
    if (json == null) {
        return json;
    }
    return {
        
        'functionDescriptions': json['functionDescriptions'],
        'naturalVariants': ((json['naturalVariants'] as Array<any>).map(NaturalVariantFromJSON)),
        'experimentalMutants': ((json['experimentalMutants'] as Array<any>).map(ExperimentalMutantFromJSON)),
        'associatedDrugs': ((json['associatedDrugs'] as Array<any>).map(AssociatedDrugFromJSON)),
        'subunit': SubunitFromJSON(json['subunit']),
        'binaryInteractions': ((json['binaryInteractions'] as Array<any>).map(BinaryInteractionFromJSON)),
        'molecularFunctions': ((json['molecularFunctions'] as Array<any>).map(GoTermFromJSON)),
        'biologicalProcesses': ((json['biologicalProcesses'] as Array<any>).map(GoTermFromJSON)),
        'resistance': ((json['resistance'] as Array<any>).map(ResistanceItemFromJSON)),
        'diseases': ((json['diseases'] as Array<any>).map(DiseaseFromJSON)),
        'publications': (mapValues(json['publications'], PublicationFromJSON)),
    };
}

export function UniprotToJSON(json: any): Uniprot {
    return UniprotToJSONTyped(json, false);
}

export function UniprotToJSONTyped(value?: Uniprot | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'functionDescriptions': value['functionDescriptions'],
        'naturalVariants': ((value['naturalVariants'] as Array<any>).map(NaturalVariantToJSON)),
        'experimentalMutants': ((value['experimentalMutants'] as Array<any>).map(ExperimentalMutantToJSON)),
        'associatedDrugs': ((value['associatedDrugs'] as Array<any>).map(AssociatedDrugToJSON)),
        'subunit': SubunitToJSON(value['subunit']),
        'binaryInteractions': ((value['binaryInteractions'] as Array<any>).map(BinaryInteractionToJSON)),
        'molecularFunctions': ((value['molecularFunctions'] as Array<any>).map(GoTermToJSON)),
        'biologicalProcesses': ((value['biologicalProcesses'] as Array<any>).map(GoTermToJSON)),
        'resistance': ((value['resistance'] as Array<any>).map(ResistanceItemToJSON)),
        'diseases': ((value['diseases'] as Array<any>).map(DiseaseToJSON)),
        'publications': (mapValues(value['publications'], PublicationToJSON)),
    };
}

